import { ItemData } from 'core/models/Template'

export const SNACKS_CATALOG_TYPE = 'snacks' as const
export const SNACKS_CATALOG_TITLE_KEY = 'snacksCatalog' as const

export const SNACKS_CATALOG_CONFIG = {
    type: SNACKS_CATALOG_TYPE,
    additionalData: {},
} as const

export type SnacksSelectedItems = ItemData[]
